import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { LiveTracker } from '../components/live-tracker';

export const BrownlowLiveTrackerProvider = ({ store, data }) => (
    <Provider store={store}>
        <LiveTracker {...data} />
    </Provider>
);

BrownlowLiveTrackerProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
